import React from "react";
import NavItemContainer from "../Smart/NavItemContainer";
export default function Sidebar({
  sideMenuItem,
  isActiveSidebar,
  isActiveSidebarSm,
  page,
}) {
  return (
    <div className="layout-sidebar">
      <div className="layout-sidebar-backdrop"></div>
      <div className="layout-sidebar-body">
        <nav
          id="sidenav"
          className="sidenav-collapse collapse"
          style={{ display: isActiveSidebar ? "block" : "" }}
        >
          <ul
            className={`sidenav ${
              !isActiveSidebarSm ? "sidenav-collapsed" : ""
            }`}
          >
            <li className="sidenav-heading">OS Menu</li>
            {sideMenuItem.map((m, idx) => {
              return <NavItemContainer pageCurrent={page} key={idx} {...m} />;
            })}
          </ul>
        </nav>
      </div>
    </div>
  );
}
